import { render, staticRenderFns } from "./MoreStyle.vue?vue&type=template&id=07471bb2&"
import script from "./MoreStyle.vue?vue&type=script&lang=js&"
export * from "./MoreStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports